import React from 'react';

import LinkToModal from '../../LinkToModal';
import ModalContent from './ModalContent';


export default () => (
  <>
    <LinkToModal
      linkText="Further Information to renew a CPCS Blue Competent Operator card"
    >
      <ModalContent />
    </LinkToModal>
  </>
);
